import type { ScreenEntry } from "./types";

// Source: psyna-cpo product/research/admin-console.md, section V.1 (verbatim).
export const SCREENS = [
  {
    id: "texts-ai",
    path: "/admin/texts-ai",
    name: "Texts & AI",
    description:
      "Какой ИИ пишет тексты, насколько длинные и разнообразные они выходят и что хранится в журнале.",
  },
  {
    id: "features",
    path: "/admin/features",
    name: "Features & Launch",
    description:
      "Что включено для пользователей: функции и веб-версия, главный выключатель каждой функции сверху.",
  },
  {
    id: "money",
    path: "/admin/money",
    name: "Money",
    description: "Что бесплатно и что платно, цены и товары, выручка и расходы.",
  },
  {
    id: "people",
    path: "/admin/people",
    name: "People",
    description:
      "Люди: поиск, карточка, помощь пользователю, и то, что человек видит на Today, в пушах и в переключателе языка.",
  },
  {
    id: "forms",
    path: "/admin/forms",
    name: "Generator & Forms",
    description:
      "Готовые формы текстов вместо ИИ: включение по языкам и проценту, пороги отката на ИИ. Экрана форм (библиотека, включение, вычитка) в админке нет, активация идёт скриптом.",
  },
  {
    id: "service",
    path: "/admin/service",
    name: "Service",
    description:
      "Аварийные выключатели, фоновые задачи, аналитика использования и журнал действий админов.",
  },
] as const satisfies readonly ScreenEntry[];
